import { FormRowProps, typedMemo } from "src/types";

export const FormRow = typedMemo(
  ({
    firstField,
    secondField,
    full_row = false,
    bp_layout = "md",
  }: FormRowProps) => {
    return (
      <div className={`d-block d-${bp_layout}-flex`}>
        {firstField && (
          <div
            className={`${full_row && !secondField ? "col" : `col-sm-12 col-${bp_layout}-6 p-0 pe-${bp_layout}-5`}`}
          >
            {firstField}
          </div>
        )}
        {secondField && (
          <div
            className={`${full_row && !firstField ? "col" : `col-sm-12 col-${bp_layout}-6 p-0 ps-${bp_layout}-5`}`}
          >
            {secondField}
          </div>
        )}
      </div>
    );
  }
);
